module.exports = __webpack_public_path__ + "img/icon-egame.5e5ef06.webp";